import React, { type ReactNode } from 'react';
import styled from 'styled-components';
import IconClose from '@components/icons/IconClose';
import {
  $playerWidgetsApi,
  type PlayerWidgetType,
} from '@stores/playerWidgets';

interface Props {
  title: string;
  width?: number;
  children: ReactNode;
  type?: PlayerWidgetType;
}

const Container = styled.div`
  &::-webkit-scrollbar {
    background-color: transparent;
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background-color: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: rgba(239, 239, 239, 0.2);
    border-radius: 3px;
    border: 0;
  }

  &::-webkit-scrollbar-button {
    display: none;
  }
`;

function WidgetItem({ title, width = 200, children, type }: Props) {
  return (
    <Container
      style={{ width }}
      className="pointer-events-auto mr-10 max-h-full overflow-y-scroll rounded bg-black py-10 pl-10 pr-4"
    >
      <div className="mb-10 flex items-center justify-between">
        {title}
        {!!type && (
          <IconClose
            onClick={() => {
              $playerWidgetsApi.remove(type);
            }}
          />
        )}
      </div>
      {children}
    </Container>
  );
}

export default WidgetItem;
